import React from 'react';
import { Box } from '@mui/material';
import ClockLoader from './ClockLoader';

/** Full-width loading block; uses {@link ClockLoader} (primary theme color). */
const LoadingSpinner = ({ message = 'Loading...', height = '200px', size = 40 }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={height} width="100%">
      <ClockLoader size={size} message={message} />
    </Box>
  );
};

export default LoadingSpinner;
